import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Element } from '../html/element'
import { DropdownItem } from './DropdownItem'
import classes from './index.module.scss'

export const DropdownList = ({
  data,
  onClickItem,
  onDidMount,
  renderDropdownItem,
  childrenRef,
  isNoWrap,
  appendItemStyle,
  appendDropdownStyle,
  activeItem,
}) => {
  useEffect(() => {
    if (onDidMount) {
      onDidMount()
    }
  }, [])

  return (
    <Element
      elementName="ul"
      className={classes.dropdown}
      style={{
        backgroundColor: '#F3F3F3',
        whiteSpace: isNoWrap ? 'nowrap' : 'unset',
        ...appendDropdownStyle,
      }}
    >
      {data.map((item, index) => {
        return (
          <DropdownItem
            activeItem={activeItem}
            key={item.value || index}
            item={item}
            onClickItem={onClickItem}
            renderDropdownItem={renderDropdownItem}
            childrenRef={childrenRef}
            appendItemStyle={appendItemStyle}
          />
        )
      })}
    </Element>
  )
}

DropdownList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]),
      route: PropTypes.string,
      isActive: PropTypes.bool,
      isI18n: PropTypes.bool,
    }),
  ).isRequired,
  onClickItem: PropTypes.func,
  onDidMount: PropTypes.func,
  renderDropdownItem: PropTypes.func,
  isNoWrap: PropTypes.bool,
  activeItem: PropTypes.object,
}

DropdownList.defaultProps = {
  onClickItem: () => {},
  isNoWrap: false,
}
